<template>
<div>
  <div class="wistia_embed wistia_async_5hb1i7ln44">
    &nbsp;
  </div>

  <div
    id="vid-embeds-2-1"
    class="tbk-vid-embed mobile-white-background"
  >
    <div id="vid-question">
      Where do you think the US ranks in terms of how long a the average person lives?
    </div>

    <a
      class="embedded_video"
      href="#wistia_qcwnla5zai?videoFoam=true"
    >
      <button id="top-ten">Top 10</button>
    </a>

    <a
      class="embedded_video"
      href="#wistia_3uujetxkca?videoFoam=true"
    >
      <button id="ten-and-thirty">Between 10 and 30</button>
    </a>

    <a
      class="embedded_video"
      href="#wistia_j73ugrp43u?videoFoam=true"
    >
      <button id="over-thirty">Over 30</button>
    </a>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    _wq.push({
      '5hb': this.showSelect,
      qcw: this.showSelect,
      '3uu': this.showSelect,
      j73: this.showSelect
    })

    if (this.tbk.isMobile()) {
      _wq.push({
        qcw: this.tbk.autoPlay,
        '3uu': this.tbk.autoPlay,
        j73: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect(video) {
      const that = this
      video.bind('end', function() {
        if (this.hashedId() !== '5hb1i7ln44') {
          $('#vid-question').text('Try a different response.')
        }
        $('.tbk-vid-embed').show()
        that.tbk.hideMobileControls()
      })
    }
  }
}
</script>

<style scoped lang="sass">
#vid-embeds-2-1
  display: none
  font-family: "azo-sans-web", sans-serif
  button
    &:hover
      opacity: 0.85
  a:link.embedded_video
    color: #fff !important
    font-size: 16px
    font-weight: 600
    font-style: normal
    line-height: 1.4em
    text-decoration: none
.tbk-vid-embed
  #vid-question
    position: relative
    top: calc(100% * (100 / 360))
    color: rgb(0, 0, 0)
    font-size: 30px
    font-weight: normal
    font-style: normal
    padding: 9.4321px
    text-align: center
  button
    background: #e74c3c
    border: none
    box-shadow: 0 .4em 0 0 #f9d2ce
    cursor: pointer
    display: table
    line-height: 1em
    padding: .875em 2em
    font-size: 16px
    border-radius: .6em
    -moz-border-radius: .6em
    -webkit-border-radius: .6em
#top-ten
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (65 / 640))
  width: calc(100% * (150 / 640))
  height: calc(100% * (45 / 360))
#ten-and-thirty
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (235 / 640))
  width: calc(100% * (170 / 640))
  height: calc(100% * (45 / 360))
  vertical-align: middle
#over-thirty
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (430 / 640))
  width: calc(100% * (150 / 640))
  height: calc(100% * (45 / 360))

@media (max-width: 450px)
  #vid-embeds-2-1
    #vid-question
      font-size: 18px
  #vid-embeds-2-1 button
    font-size: 12px
    line-height: 10px
    padding: 1px 2px
  #ten-and-thirty
    line-height: 13px
    padding: 4px 2px 28px 2px
</style>
